import React, { useEffect, useState } from "react";
import { notify, getPractice, can_visit } from "../../../helpers";
import { useDocumentTitle } from "../../../hooks/customDocumentTitleHook";
import { setDummyCall, setDummySMS } from "../../../services/message";
import Spacing from "../../Spacing";

export default function DummyModeSetup({selectedPracticeChange, fetchChangePracticeData, smsLimit, setSmsLimit}) {

  let account_id = getPractice("account_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    account_id = selectedPracticeChange?.account_id;
  }

  const [smsInformations, setSmsInformations] = useState({
    account_id: account_id,
    dummy_sms: smsLimit.dummy_sms
  });

  const [callInformations, setCallInformations] = useState({
    account_id: account_id,
    dummy_call: smsLimit.dummy_call
  });

  const handleSmsChange = async (e) => {
    const value = !smsInformations.dummy_sms;
    const updatedSmsInfo = { ...smsInformations, dummy_sms: value };
    setSmsInformations(updatedSmsInfo);
    setSmsLimit({ ...smsLimit, dummy_sms: value });
    
    if(can_visit("settings_dummy_sms_setup")) {
      try {
        const result = await setDummySMS(updatedSmsInfo);

        if (result?.data?.status === 'error') {
          notify('error', result?.data?.message);
        } else {
          notify('success', result?.data?.message);
        }
      } catch (error) {
        notify("error", "Error setting dummy SMS");
      }
    }
  };

  const handleCallChange = async (e) => {
    const value = !callInformations.dummy_call;
    const updatedCallInfo = { ...callInformations, dummy_call: value };
    setCallInformations(updatedCallInfo);
    setSmsLimit({ ...smsLimit, dummy_call: value });
    
    if(can_visit("settings_dummy_call_setup")) {
      try {
        const result = await setDummyCall(updatedCallInfo);

        if (result?.data?.status === 'error') {
          notify('error', result?.data?.message);
        } else {
          notify('success', result?.data?.message);
        }
      } catch (error) {
        notify("error", "Error setting dummy call");
      }
    }
  };

  useEffect(() => {
    setSmsInformations({
      ...smsInformations,
      account_id: account_id,
      dummy_sms: smsLimit?.dummy_sms,
    });
    setCallInformations({
      ...smsInformations,
      account_id: account_id,
      dummy_call: smsLimit?.dummy_call,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id, smsLimit]);

  useDocumentTitle("Message & Call Preferences");

  return (
    <>
      {can_visit("settings_dummy_sms_setup") && (
        <div className='docpro_border_heading_card card_700'>
          <div className="card_heading">
            <h1 className="mb-0 docpro_fs_18">Message Preference</h1>
          </div>

          <div className="card_body">
            <div className="docpro_mode_toggle">
              <h6 className="fw-500 primary-color mb-0"> Message Mode: </h6>
              <label className="switch switch_mode mb-0">
                <input
                  name="dummy_sms"
                  checked={!smsInformations?.dummy_sms || false}
                  onChange={handleSmsChange}
                  type="checkbox"
                  className="docpro_logo_color"
                />
                <span className="slider"></span>
              </label>
            </div>
            
            <Spacing lg="18" sm="18" />
            <p className="docpro_fs_14 docpro_mb_0">
              {smsInformations?.dummy_sms ? 
                <span className="docpro_red_color">Message delivery is currently blocked; no one can receive messages.</span>
              :
                <span className="docpro_green_color">Message delivery is currently active; everyone can receive messages.</span>
              }
            </p>
          </div>
        </div>
      )}
      <Spacing lg="25" sm="25" />

      {can_visit("settings_dummy_call_setup") && (
        <div className='docpro_border_heading_card card_700'>
          <div className="card_heading">
            <h1 className="mb-0 docpro_fs_18">Call Preference</h1>
          </div>

          <div className="card_body">
            <div className="docpro_mode_toggle">
              <h6 className="fw-500 primary-color mb-0"> Call Mode: </h6>
              <label className="switch switch_mode mb-0">
                <input
                  name="dummy_call"
                  checked={!callInformations?.dummy_call || false}
                  onChange={handleCallChange}
                  type="checkbox"
                  className="docpro_logo_color"
                />
                <span className="slider"></span>
              </label>
            </div>

            <Spacing lg="18" sm="18" />
            <p className="docpro_fs_14 docpro_mb_0">
              {callInformations?.dummy_call ? 
                <span className="docpro_red_color">Call receiving is currently disabled; no one can receive calls.</span>
              :
                <span className="docpro_green_color">Call receiving is currently enabled; everyone can receive calls.</span>
              }
            </p>
          </div>
        </div>
      )}
    </>
  );
}
